import * as React from "react";
import { useNavigate } from "react-router-dom";

import { InteractionStatus } from "@azure/msal-browser";
import { useMsal } from "@azure/msal-react";
import { CircularProgress } from "@mui/material";

import { payLinkPasswordlessRequest } from "../../../../config";
import { usePayLinkCart } from "../../context/PayLinkCartContext";

export const PayLinkLogin = () => {
  const { instance, accounts, inProgress } = useMsal();
  const { storeProfile } = usePayLinkCart();

  const navigate = useNavigate();
  const loginAttempted = React.useRef(false);

  React.useEffect(() => {
    if (inProgress !== InteractionStatus.None) return;

    const login = async () => {
      const isLoggedIn = accounts && accounts.length >= 1;

      if (isLoggedIn) {
        navigate("/paylink/session", { replace: true });
        return;
      }

      if (loginAttempted.current) return;
      loginAttempted.current = true;

      localStorage.setItem("redirectUrl", "/paylink/session");
      localStorage.setItem("mode", "email");
      localStorage.setItem("loginFlow", "paylink");

      try {
        await instance.loginRedirect({
          ...payLinkPasswordlessRequest,
          extraQueryParameters: {
            custom_name: storeProfile?.storeName ?? "Store",
          },
        });
      } catch (err) {
        console.error(err);
        loginAttempted.current = false;
      }
    };

    login();
  }, [instance, accounts, inProgress, navigate]);

  return (
    <section className="w-full min-h-screen bg-white flex items-center justify-center px-6">
      <div className="flex flex-col items-center gap-4 text-center">
        <CircularProgress size={28} />
        <p className="text-sm text-py_black-500">
          Signing you in, please wait...
        </p>
      </div>
    </section>
  );
};
